var Backbone, FAQArticleView, FAQAutoCompleteView, FAQAutoSuggestionListView, FAQBreadCrumbView, FAQContentModel, FAQHomeModel, FAQMainView, FAQTopicView, FAQTrendingArticlesView, FAQV1AutoSuggestionListView, FAQV2AutoSuggestionListView, FAQViewManagerView, SharedAjaxErrorView,
  extend = function(child, parent) { for (var key in parent) { if (hasProp.call(parent, key)) child[key] = parent[key]; } function ctor() { this.constructor = child; } ctor.prototype = parent.prototype; child.prototype = new ctor(); child.__super__ = parent.prototype; return child; },
  hasProp = {}.hasOwnProperty;

FAQMainView = require('./main');

FAQArticleView = require('./article');

FAQBreadCrumbView = require('./breadcrumb');

FAQTopicView = require('./topic');

FAQAutoCompleteView = require('./autocomplete');

SharedAjaxErrorView = require('../../../shared/frontend/views/ajax_error_view');

FAQV1AutoSuggestionListView = require('./v1_autosuggestionlist');

FAQV2AutoSuggestionListView = require('./v2_autosuggestionlist');

FAQContentModel = require('../models/content');

FAQHomeModel = require('../models/home');

FAQAutoSuggestionListView = require('./autosuggestionlist');

FAQTrendingArticlesView = require('./trendingArticles');

Backbone = require('backbone');

Backbone.$ = $;

FAQViewManagerView = (function(superClass) {
  extend(FAQViewManagerView, superClass);

  function FAQViewManagerView() {
    return FAQViewManagerView.__super__.constructor.apply(this, arguments);
  }

  FAQViewManagerView.prototype.initialize = function() {
    _.bind(this.renderErrorHtml, this);
    this.faqContentContainer = $('#content-container');
    this.errorContainer = $('#error-container');
    this.spinner = $('.g-spinner');
    this.contentModel = new FAQContentModel();
    this.homeModel = new FAQHomeModel();
    this.breadCrumbView = new FAQBreadCrumbView();
    this.errorView = new SharedAjaxErrorView();
    this.autoCompleteView = new FAQAutoCompleteView({
      'container': $('#auto-complete-container')
    });
    this.autoCompleteView.render();
    if (this.isV2View()) {
      return this.renderTrendingArticles();
    }
  };

  FAQViewManagerView.prototype.render = function(requestId) {
    var splitIds, viewId;
    $(window).scrollTop(0);
    splitIds = this.splitRequestId(requestId);
    viewId = this.findViewID(splitIds);
    this.autoCompleteView.invalidate();
    this.breadCrumbView.invalidate();
    this.renderFooter();
    if (viewId != null) {
      if (this.currentView != null) {
        this.currentView.remove();
      }
      switch (viewId) {
        case FAQMainView.VIEWID:
          return this.constructFaqMainView();
        case FAQTopicView.VIEWID:
          return this.constructTopicView(splitIds[0]);
        case FAQArticleView.VIEWID:
          return this.constructArticleView(splitIds[0], splitIds[1]);
        case FAQAutoSuggestionListView.VIEWID:
          return this.constructAutoSuggestionListView(splitIds[1]);
      }
    } else {
      return this.renderErrorHtml({
        query: requestId
      });
    }
  };

  FAQViewManagerView.prototype.splitRequestId = function(requestId) {
    return requestId.split(window.ID_seperator);
  };

  FAQViewManagerView.prototype.findViewID = function(splitIds) {
    var baseId;
    if (!((splitIds != null ? splitIds.length : void 0) > 0)) {
      return null;
    }
    baseId = splitIds[0];
    if (splitIds.length === 1) {
      if (baseId === FAQMainView.VIEWNAME) {
        return FAQMainView.VIEWID;
      } else {
        return FAQTopicView.VIEWID;
      }
    } else {
      if (baseId === FAQAutoSuggestionListView.VIEWNAME) {
        return FAQAutoSuggestionListView.VIEWID;
      }
      return FAQArticleView.VIEWID;
    }
  };

  FAQViewManagerView.prototype.constructFaqMainView = function(topicId) {
    if (topicId == null) {
      topicId = null;
    }
    this.currentView = new FAQMainView({
      'breadCrumbView': this.breadCrumbView,
      'container': this.faqContentContainer,
      'errorContainer': this.errorContainer,
      'spinner': this.spinner,
      'homeModel': this.homeModel,
      'errorView': this.errorView,
      'topic': topicId
    });
    this.currentView.render();
    if (this.isV2View()) {
      this.hideFooter();
      if (topicId == null) {
        return scrollTo($('.contact-us'));
      }
    }
  };

  FAQViewManagerView.prototype.renderTrendingArticles = function() {
    return this.homeModel.fetch({
      success: (function(_this) {
        return function(model, response, options) {
          var trendingArticlesView;
          stopTimer("t_fh");
          $('.trending-articles-container').show();
          trendingArticlesView = new FAQTrendingArticlesView({
            model: _this.homeModel
          });
          return trendingArticlesView.render();
        };
      })(this),
      error: (function(_this) {
        return function(model, xhr, options) {
          $('.trending-articles-container').hide();
          return stopTimer("t_fh");
        };
      })(this)
    });
  };

  FAQViewManagerView.prototype.renderFooter = function() {
    return $('.faq-footer').show();
  };

  FAQViewManagerView.prototype.hideFooter = function() {
    return $('.faq-footer').hide();
  };

  FAQViewManagerView.prototype.constructTopicView = function(topicId) {
    if (this.isV2View()) {
      return this.constructFaqMainView(topicId);
    } else {
      this.currentView = new FAQTopicView({
        'breadCrumbView': this.breadCrumbView,
        'contentModel': this.contentModel,
        'container': this.faqContentContainer,
        'errorContainer': this.errorContainer,
        'spinner': this.spinner
      });
      return this.currentView.render(topicId);
    }
  };

  FAQViewManagerView.prototype.constructArticleView = function(topicId, articleId) {
    this.currentView = new FAQArticleView({
      'breadCrumbView': this.breadCrumbView,
      'contentModel': this.contentModel,
      'summarized': false,
      'container': this.faqContentContainer,
      'errorContainer': this.errorContainer,
      'spinner': this.spinner
    });
    this.currentView.render(topicId, articleId);
    if (this.isV2View()) {
      return scrollTo($('.tabs-container'));
    }
  };

  FAQViewManagerView.prototype.constructAutoSuggestionListView = function(searchText) {
    var options;
    options = {
      'breadCrumbView': this.breadCrumbView,
      'container': this.faqContentContainer,
      'errorContainer': this.errorContainer,
      'spinner': this.spinner
    };
    if (this.isV2View()) {
      this.currentView = new FAQV2AutoSuggestionListView(options);
    } else {
      this.currentView = new FAQV1AutoSuggestionListView(options);
    }
    return this.currentView.render(searchText);
  };

  FAQViewManagerView.prototype.isV2View = function() {
    return evaluate(typeof experiments !== "undefined" && experiments !== null ? experiments.showVerticalPageFlow : void 0);
  };

  FAQViewManagerView.prototype.scrollToFAQSearch = function() {
    return scrollTo($('#faqs'));
  };

  FAQViewManagerView.prototype.renderErrorHtml = function(hash) {
    var data;
    if (hash == null) {
      hash = {};
    }
    this.breadCrumbView.invalidate();
    if (hash.query != null) {
      data = {
        searchId: hash.query,
        text: (I18n.t('js.modules.faq.search_result')) + "'" + hash.query + "'"
      };
      this.breadCrumbView.addCrumbs(data);
    }
    this.breadCrumbView.render();
    this.errorView.render(hash);
    this.constructFaqMainView();
    return this.scrollToFAQSearch();
  };

  return FAQViewManagerView;

})(Backbone.View);

module.exports = FAQViewManagerView;

//# sourceMappingURL=data:application/json;base64,eyJ2ZXJzaW9uIjozLCJmaWxlIjoiL3Zhci9ncm91cG9uL2hvbWUva3VtYXJyYS9uYXBpc3RyYW5vL2J1aWxkLzE1MDQ3NzgxNDM1MjYtNzYxNzcvcHJvZHVjdGlvbi0yMDE3LjA5LjA3XzA5LjU0L3N1cHBvcnRfYXBwL21vZHVsZXMvZmFxL2Zyb250ZW5kL3ZpZXdzL3ZpZXdtYW5hZ2VyLmNvZmZlZSIsInNvdXJjZVJvb3QiOiIiLCJzb3VyY2VzIjpbIi92YXIvZ3JvdXBvbi9ob21lL2t1bWFycmEvbmFwaXN0cmFuby9idWlsZC8xNTA0Nzc4MTQzNTI2LTc2MTc3L3Byb2R1Y3Rpb24tMjAxNy4wOS4wN18wOS41NC9zdXBwb3J0X2FwcC9tb2R1bGVzL2ZhcS9mcm9udGVuZC92aWV3cy92aWV3bWFuYWdlci5jb2ZmZWUiXSwibmFtZXMiOltdLCJtYXBwaW5ncyI6IkFBQUEsSUFBQSxpUkFBQTtFQUFBOzs7QUFBQSxXQUFBLEdBQWMsT0FBQSxDQUFRLFFBQVI7O0FBQ2QsY0FBQSxHQUFpQixPQUFBLENBQVEsV0FBUjs7QUFDakIsaUJBQUEsR0FBb0IsT0FBQSxDQUFRLGNBQVI7O0FBQ3BCLFlBQUEsR0FBZSxPQUFBLENBQVEsU0FBUjs7QUFDZixtQkFBQSxHQUFzQixPQUFBLENBQVEsZ0JBQVI7O0FBQ3RCLG1CQUFBLEdBQXNCLE9BQUEsQ0FBUSxnREFBUjs7QUFDdEIsMkJBQUEsR0FBOEIsT0FBQSxDQUFRLHlCQUFSOztBQUM5QiwyQkFBQSxHQUE4QixPQUFBLENBQVEseUJBQVI7O0FBQzlCLGVBQUEsR0FBa0IsT0FBQSxDQUFRLG1CQUFSOztBQUNsQixZQUFBLEdBQWUsT0FBQSxDQUFRLGdCQUFSOztBQUNmLHlCQUFBLEdBQTRCLE9BQUEsQ0FBUSxzQkFBUjs7QUFDNUIsdUJBQUEsR0FBMEIsT0FBQSxDQUFRLG9CQUFSOztBQUMxQixRQUFBLEdBQVcsT0FBQSxDQUFRLFVBQVI7O0FBQ1gsUUFBUSxDQUFDLENBQVQsR0FBYTs7QUFFUDs7Ozs7OzsrQkFDSixVQUFBLEdBQVksU0FBQTtJQUNWLENBQUMsQ0FBQyxJQUFGLENBQU8sSUFBQyxDQUFBLGVBQVIsRUFBeUIsSUFBekI7SUFDQSxJQUFDLENBQUEsbUJBQUQsR0FBdUIsQ0FBQSxDQUFFLG9CQUFGO0lBQ3ZCLElBQUMsQ0FBQSxjQUFELEdBQWtCLENBQUEsQ0FBRSxrQkFBRjtJQUNsQixJQUFDLENBQUEsT0FBRCxHQUFXLENBQUEsQ0FBRSxZQUFGO0lBQ1gsSUFBQyxDQUFBLFlBQUQsR0FBZ0IsSUFBSSxlQUFKLENBQUE7SUFDaEIsSUFBQyxDQUFBLFNBQUQsR0FBYSxJQUFJLFlBQUosQ0FBQTtJQUNiLElBQUMsQ0FBQSxjQUFELEdBQWtCLElBQUksaUJBQUosQ0FBQTtJQUNsQixJQUFDLENBQUEsU0FBRCxHQUFhLElBQUksbUJBQUosQ0FBQTtJQUNiLElBQUMsQ0FBQSxnQkFBRCxHQUFvQixJQUFJLG1CQUFKLENBQXdCO01BQzFDLFdBQUEsRUFBYyxDQUFBLENBQUUsMEJBQUYsQ0FENEI7S0FBeEI7SUFHcEIsSUFBQyxDQUFBLGdCQUFnQixDQUFDLE1BQWxCLENBQUE7SUFDQSxJQUE2QixJQUFDLENBQUEsUUFBRCxDQUFBLENBQTdCO2FBQUEsSUFBQyxDQUFBLHNCQUFELENBQUEsRUFBQTs7RUFiVTs7K0JBZ0JaLE1BQUEsR0FBUSxTQUFDLFNBQUQ7QUFDTixRQUFBO0lBQUEsQ0FBQSxDQUFFLE1BQUYsQ0FBUyxDQUFDLFNBQVYsQ0FBb0IsQ0FBcEI7SUFDQSxRQUFBLEdBQVcsSUFBQyxDQUFBLGNBQUQsQ0FBZ0IsU0FBaEI7SUFDWCxNQUFBLEdBQVMsSUFBQyxDQUFBLFVBQUQsQ0FBWSxRQUFaO0lBQ1QsSUFBQyxDQUFBLGdCQUFnQixDQUFDLFVBQWxCLENBQUE7SUFDQSxJQUFDLENBQUEsY0FBYyxDQUFDLFVBQWhCLENBQUE7SUFDQSxJQUFDLENBQUEsWUFBRCxDQUFBO0lBQ0EsSUFBRyxjQUFIO01BQ0UsSUFBeUIsd0JBQXpCO1FBQUEsSUFBQyxDQUFBLFdBQVcsQ0FBQyxNQUFiLENBQUEsRUFBQTs7QUFDQSxjQUFPLE1BQVA7QUFBQSxhQUNPLFdBQVcsQ0FBQyxNQURuQjtpQkFDK0IsSUFBQyxDQUFBLG9CQUFELENBQUE7QUFEL0IsYUFFTyxZQUFZLENBQUMsTUFGcEI7aUJBRWdDLElBQUMsQ0FBQSxrQkFBRCxDQUFvQixRQUFTLENBQUEsQ0FBQSxDQUE3QjtBQUZoQyxhQUdPLGNBQWMsQ0FBQyxNQUh0QjtpQkFHa0MsSUFBQyxDQUFBLG9CQUFELENBQXNCLFFBQVMsQ0FBQSxDQUFBLENBQS9CLEVBQW1DLFFBQVMsQ0FBQSxDQUFBLENBQTVDO0FBSGxDLGFBSU8seUJBQXlCLENBQUMsTUFKakM7aUJBSTZDLElBQUMsQ0FBQSwrQkFBRCxDQUFpQyxRQUFTLENBQUEsQ0FBQSxDQUExQztBQUo3QyxPQUZGO0tBQUEsTUFBQTthQVFFLElBQUMsQ0FBQSxlQUFELENBQWlCO1FBQ2YsS0FBQSxFQUFRLFNBRE87T0FBakIsRUFSRjs7RUFQTTs7K0JBbUJSLGNBQUEsR0FBaUIsU0FBQyxTQUFEO0FBQ2YsV0FBTyxTQUFTLENBQUMsS0FBVixDQUFnQixNQUFNLENBQUMsWUFBdkI7RUFEUTs7K0JBR2pCLFVBQUEsR0FBYSxTQUFDLFFBQUQ7QUFDWCxRQUFBO0lBQUEsSUFBQSxDQUFBLHFCQUFtQixRQUFRLENBQUUsZ0JBQVYsR0FBbUIsQ0FBdEMsQ0FBQTtBQUFBLGFBQU8sS0FBUDs7SUFDQSxNQUFBLEdBQVMsUUFBUyxDQUFBLENBQUE7SUFDbEIsSUFBRyxRQUFRLENBQUMsTUFBVCxLQUFtQixDQUF0QjtNQUNFLElBQUcsTUFBQSxLQUFVLFdBQVcsQ0FBQyxRQUF6QjtBQUNDLGVBQU8sV0FBVyxDQUFDLE9BRHBCO09BQUEsTUFBQTtBQUdDLGVBQU8sWUFBWSxDQUFDLE9BSHJCO09BREY7S0FBQSxNQUFBO01BTUUsSUFBRyxNQUFBLEtBQVUseUJBQXlCLENBQUMsUUFBdkM7QUFDRSxlQUFPLHlCQUF5QixDQUFDLE9BRG5DOztBQUVBLGFBQU8sY0FBYyxDQUFDLE9BUnhCOztFQUhXOzsrQkFjYixvQkFBQSxHQUFzQixTQUFDLE9BQUQ7O01BQUMsVUFBVTs7SUFDL0IsSUFBQyxDQUFBLFdBQUQsR0FBZSxJQUFJLFdBQUosQ0FBZ0I7TUFDN0IsZ0JBQUEsRUFBb0IsSUFBQyxDQUFBLGNBRFE7TUFFN0IsV0FBQSxFQUFvQixJQUFDLENBQUEsbUJBRlE7TUFHN0IsZ0JBQUEsRUFBb0IsSUFBQyxDQUFBLGNBSFE7TUFJN0IsU0FBQSxFQUFvQixJQUFDLENBQUEsT0FKUTtNQUs3QixXQUFBLEVBQW9CLElBQUMsQ0FBQSxTQUxRO01BTTdCLFdBQUEsRUFBb0IsSUFBQyxDQUFBLFNBTlE7TUFPN0IsT0FBQSxFQUFvQixPQVBTO0tBQWhCO0lBU2YsSUFBQyxDQUFBLFdBQVcsQ0FBQyxNQUFiLENBQUE7SUFDQSxJQUFHLElBQUMsQ0FBQSxRQUFELENBQUEsQ0FBSDtNQUNFLElBQUMsQ0FBQSxVQUFELENBQUE7TUFDQSxJQUFJLGVBQUo7ZUFDRSxRQUFBLENBQVMsQ0FBQSxDQUFFLGFBQUYsQ0FBVCxFQURGO09BRkY7O0VBWG9COzsrQkFnQnRCLHNCQUFBLEdBQXdCLFNBQUE7V0FDdEIsSUFBQyxDQUFBLFNBQVMsQ0FBQyxLQUFYLENBQ0U7TUFBQSxPQUFBLEVBQVMsQ0FBQSxTQUFBLEtBQUE7ZUFBQSxTQUFFLEtBQUYsRUFBUyxRQUFULEVBQW1CLE9BQW5CO0FBQ1AsY0FBQTtVQUFBLFNBQUEsQ0FBVSxNQUFWO1VBQ0EsQ0FBQSxDQUFFLDhCQUFGLENBQWlDLENBQUMsSUFBbEMsQ0FBQTtVQUNBLG9CQUFBLEdBQXVCLElBQUksdUJBQUosQ0FBNEI7WUFBQSxLQUFBLEVBQU8sS0FBQyxDQUFBLFNBQVI7V0FBNUI7aUJBQ3ZCLG9CQUFvQixDQUFDLE1BQXJCLENBQUE7UUFKTztNQUFBLENBQUEsQ0FBQSxDQUFBLElBQUEsQ0FBVDtNQUtBLEtBQUEsRUFBTyxDQUFBLFNBQUEsS0FBQTtlQUFBLFNBQUUsS0FBRixFQUFTLEdBQVQsRUFBYyxPQUFkO1VBQ0wsQ0FBQSxDQUFFLDhCQUFGLENBQWlDLENBQUMsSUFBbEMsQ0FBQTtpQkFDQSxTQUFBLENBQVUsTUFBVjtRQUZLO01BQUEsQ0FBQSxDQUFBLENBQUEsSUFBQSxDQUxQO0tBREY7RUFEc0I7OytCQVd4QixZQUFBLEdBQWUsU0FBQTtXQUNiLENBQUEsQ0FBRSxhQUFGLENBQWdCLENBQUMsSUFBakIsQ0FBQTtFQURhOzsrQkFHZixVQUFBLEdBQVksU0FBQTtXQUNWLENBQUEsQ0FBRSxhQUFGLENBQWdCLENBQUMsSUFBakIsQ0FBQTtFQURVOzsrQkFJWixrQkFBQSxHQUFvQixTQUFDLE9BQUQ7SUFDbEIsSUFBRyxJQUFDLENBQUEsUUFBRCxDQUFBLENBQUg7YUFDRSxJQUFDLENBQUEsb0JBQUQsQ0FBc0IsT0FBdEIsRUFERjtLQUFBLE1BQUE7TUFHRSxJQUFDLENBQUEsV0FBRCxHQUFlLElBQUksWUFBSixDQUFpQjtRQUM5QixnQkFBQSxFQUFvQixJQUFDLENBQUEsY0FEUztRQUU5QixjQUFBLEVBQXFCLElBQUMsQ0FBQSxZQUZRO1FBRzlCLFdBQUEsRUFBb0IsSUFBQyxDQUFBLG1CQUhTO1FBSTlCLGdCQUFBLEVBQW1CLElBQUMsQ0FBQSxjQUpVO1FBSzlCLFNBQUEsRUFBb0IsSUFBQyxDQUFBLE9BTFM7T0FBakI7YUFPZixJQUFDLENBQUEsV0FBVyxDQUFDLE1BQWIsQ0FBb0IsT0FBcEIsRUFWRjs7RUFEa0I7OytCQWNwQixvQkFBQSxHQUFzQixTQUFDLE9BQUQsRUFBVSxTQUFWO0lBQ3BCLElBQUMsQ0FBQSxXQUFELEdBQWUsSUFBSSxjQUFKLENBQW1CO01BQ2hDLGdCQUFBLEVBQW9CLElBQUMsQ0FBQSxjQURXO01BRWhDLGNBQUEsRUFBcUIsSUFBQyxDQUFBLFlBRlU7TUFHaEMsWUFBQSxFQUFvQixLQUhZO01BSWhDLFdBQUEsRUFBb0IsSUFBQyxDQUFBLG1CQUpXO01BS2hDLGdCQUFBLEVBQW9CLElBQUMsQ0FBQSxjQUxXO01BTWhDLFNBQUEsRUFBb0IsSUFBQyxDQUFBLE9BTlc7S0FBbkI7SUFRZixJQUFDLENBQUEsV0FBVyxDQUFDLE1BQWIsQ0FBb0IsT0FBcEIsRUFBNkIsU0FBN0I7SUFDQSxJQUFrQyxJQUFDLENBQUEsUUFBRCxDQUFBLENBQWxDO2FBQUEsUUFBQSxDQUFTLENBQUEsQ0FBRSxpQkFBRixDQUFULEVBQUE7O0VBVm9COzsrQkFZdEIsK0JBQUEsR0FBa0MsU0FBQyxVQUFEO0FBQ2hDLFFBQUE7SUFBQSxPQUFBLEdBQVU7TUFDUixnQkFBQSxFQUFvQixJQUFDLENBQUEsY0FEYjtNQUVSLFdBQUEsRUFBb0IsSUFBQyxDQUFBLG1CQUZiO01BR1IsZ0JBQUEsRUFBb0IsSUFBQyxDQUFBLGNBSGI7TUFJUixTQUFBLEVBQW9CLElBQUMsQ0FBQSxPQUpiOztJQU1WLElBQUcsSUFBQyxDQUFBLFFBQUQsQ0FBQSxDQUFIO01BQ0UsSUFBQyxDQUFBLFdBQUQsR0FBZSxJQUFJLDJCQUFKLENBQWdDLE9BQWhDLEVBRGpCO0tBQUEsTUFBQTtNQUdFLElBQUMsQ0FBQSxXQUFELEdBQWUsSUFBSSwyQkFBSixDQUFnQyxPQUFoQyxFQUhqQjs7V0FJQSxJQUFDLENBQUEsV0FBVyxDQUFDLE1BQWIsQ0FBb0IsVUFBcEI7RUFYZ0M7OytCQWFsQyxRQUFBLEdBQVUsU0FBQTtXQUNSLFFBQUEsOERBQVMsV0FBVyxDQUFFLDZCQUF0QjtFQURROzsrQkFHVixpQkFBQSxHQUFtQixTQUFBO1dBQ2pCLFFBQUEsQ0FBUyxDQUFBLENBQUUsT0FBRixDQUFUO0VBRGlCOzsrQkFHbkIsZUFBQSxHQUFrQixTQUFDLElBQUQ7QUFDaEIsUUFBQTs7TUFEaUIsT0FBTzs7SUFDeEIsSUFBQyxDQUFBLGNBQWMsQ0FBQyxVQUFoQixDQUFBO0lBQ0EsSUFBRyxrQkFBSDtNQUNFLElBQUEsR0FDRTtRQUFBLFFBQUEsRUFBWSxJQUFJLENBQUMsS0FBakI7UUFDQSxJQUFBLEVBQWMsQ0FBQyxJQUFJLENBQUMsQ0FBTCxDQUFPLDhCQUFQLENBQUQsQ0FBQSxHQUF3QyxHQUF4QyxHQUEyQyxJQUFJLENBQUMsS0FBaEQsR0FBc0QsR0FEcEU7O01BRUYsSUFBQyxDQUFBLGNBQWMsQ0FBQyxTQUFoQixDQUEwQixJQUExQixFQUpGOztJQUtBLElBQUMsQ0FBQSxjQUFjLENBQUMsTUFBaEIsQ0FBQTtJQUNBLElBQUMsQ0FBQSxTQUFTLENBQUMsTUFBWCxDQUFrQixJQUFsQjtJQUNBLElBQUMsQ0FBQSxvQkFBRCxDQUFBO1dBQ0EsSUFBQyxDQUFBLGlCQUFELENBQUE7RUFWZ0I7Ozs7R0FwSWEsUUFBUSxDQUFDOztBQWdKMUMsTUFBTSxDQUFDLE9BQVAsR0FBaUIifQ==
